import React from 'react';
import MobileHeaderTop from './MobileHeaderTop';
import MobileHeaderBottom from './MobileHeaderBottom';
import ToastContainer from './ToastContainer';
import LoadingSpinner from './LoadingSpinner';
import {useLocation} from "react-router-dom";
import useAuth from "../hooks/useAuth";
import {useNotifications} from "../context/NotificationsContext";
import NotificationsModal from "./Modals/NotificationsModal";

const MobileMainLayout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const hideNav = location.pathname === '/login' || location.pathname === '/forgot-password';
  const { isOpen, userId, closeNotifications } = useNotifications();

  return (
      <>
          {/* Fixed Top Header */}
          {!hideNav && <MobileHeaderTop/>}

          {/* Scrollable Main Content */}
          <div className="mobile-layout">
              {/*<div className="mobile-main-content">*/}
              {isAuthenticated !== null ? !hideNav ?
                  (<div className="mobile-main-content">{children}</div>)  :
                  children
                  : <LoadingSpinner text="Загрузка страницы..."/>}
              {/*</div>*/}
          </div>

          {/* Fixed Bottom Header */}
          {!hideNav && <MobileHeaderBottom/>}

          <ToastContainer/>
          <NotificationsModal
          isOpen={isOpen}
          onClose={closeNotifications}
          userId={userId}
        />
      </>
    );
};

export default MobileMainLayout;
